import * as React from 'react';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Chip, CssBaseline, Stack, Grid, Tooltip, Divider, Typography, Button } from '@mui/material';
import { DeveloperBoard, Instagram, Telegram, WhatsApp } from '@mui/icons-material';
import { useAppSelector } from '../../store/hooks/useAppSelector';
import { RootState } from '../../store/types/rootState';
import VipRWhite from '../../assets/images/vipr/white.png'
import VipRBlack from '../../assets/images/vipr/black.png'

// Custom styles
const styles = {
  container: {
    background: '#000', // Soft gradient background
    color: 'white',
    padding: '2rem 1rem',
    textAlign: 'center',
    borderTop: '1px solid #fff',
    boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1.5rem',
    flexWrap: 'wrap',
  },
  chip: {
    color: 'white',
    padding: '0.8rem 1.5rem',
    cursor: 'pointer',
    borderRadius: '30px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.15)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.2)',
    },
  },
  chipIcon: {
    marginRight: '8px',
  },
  footerText: {
    marginTop: '1rem',
    fontSize: '0.9rem',
    color: 'rgba(255, 255, 255, 0.8)',
  },
  divider: {
    margin: '2rem 0',
    borderColor: 'rgba(255, 255, 255, 0.3)',
  },
  mobileStack: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '1rem',
  },
  title: {
    fontSize: '30px',
    fontWeight: 'bold',
    marginBottom: '1rem',
  },
  button: {
    backgroundColor: '#ffffff',
    color: 'green',
    padding: '0.8rem',
    borderRadius: '30px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#1de9b6',
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
    },
  },
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#000',
    },
    secondary: {
      main: '#fff',
    },
  },
});

const Footer = () => {
  const accountInformation = useAppSelector(({ account }: RootState) => account);

  const openWhatsAppChat = () => {
    const whatsappUrl = `https://viprf.vercel.app`;
    window.open(whatsappUrl, '_blank');
  };


  const handleClick = (url: string) => {
    window.open(url, '_blank');
  };

  const renderCustomOptions = () => {
    const whatsappNumbers = accountInformation.socialMediaList.filter(sm => sm.name === 'supportWhatsapp');
    const telegramNumber = accountInformation.socialMediaList.find(sm => sm.name === 'supportTelegram')?.username;
    const whatsappChannel = accountInformation.socialMediaList.find(sm => sm.name === 'whatsappChannel')?.username;
    const instagramUserName = accountInformation.socialMediaList.find(sm => sm.name === 'instagram')?.username;

    return ( <Stack direction="row" justifyContent="center" spacing={2}>
        {whatsappNumbers.map((whatsappNumber) => <Tooltip title="Soporte en WhatsApp" arrow>
        <Chip
          onClick={() => {
            const message = 'Hola, necesito ayuda con mis números.';
            const whatsappUrl = `https://wa.me/${whatsappNumber.username}/?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, '_blank');
          }}
          sx={styles.chip}
          icon={<WhatsApp />}
          label="Soporte"
          variant="outlined"
        />
      </Tooltip>)}
      {telegramNumber && (
        <Tooltip title="Soporte en Telegram" arrow>
          <Chip
            onClick={() => {
              const message = 'Hola, necesito ayuda con mis números.';
              const telegramUrl = `https://t.me/${telegramNumber}`;
              window.open(telegramUrl, '_blank');
            }}
            sx={styles.chip}
            icon={<Telegram />}
            label="Soporte"
            variant="outlined"
          />
        </Tooltip>
      )}
      {whatsappChannel && (
           <Tooltip title="Canal de Whatsapp" arrow>
          <Chip
            onClick={() => {
              window.open(whatsappChannel, '_blank');
            }}
            sx={styles.chip}
            icon={<WhatsApp />}
            label="Canal de Whatsapp"
            variant="outlined"
          />
        </Tooltip>
      )}

    {instagramUserName != undefined && (
    <Tooltip title={`Instagram ${instagramUserName}`} arrow>
            <Chip
              onClick={() => handleClick(`https://www.instagram.com/${instagramUserName}`)}
              sx={styles.chip}
              icon={<Instagram />}
              label={`${instagramUserName}`}
              variant="outlined"
            />
          </Tooltip>
    )}
      
    </Stack>)
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={styles.container}>
        {/* Title section */}
        <Typography sx={styles.title} variant="h4" fontFamily={"Phrastic"} 
              fontWeight={"bold"} 
              textTransform={"uppercase"} >
          Conéctate con nosotros
        </Typography>
        
        
       
          <Box sx={styles.mobileStack}>
           {renderCustomOptions()}
           </Box>
           {accountInformation.id !== 'super-rifas-latam' && (
            <>
            <Divider sx={styles.divider} />
           <Box onClick={openWhatsAppChat}>
           <Grid container>
            <Grid xs={5} lg={5} sm={5} xl={5} md={5}>
              <Button variant='contained'>
                <Typography variant="body1" fontFamily={"Phrastic"} 
                    textAlign={"right"}
                    paddingY={2}>
                    Creador de la plataforma:
                </Typography>
              </Button>
            </Grid>
            <Grid xs={7} lg={7} sm={7} xl={7} md={7} paddingTop={2} display={"flex"} justifyContent={"start"}>
              <img src={VipRBlack} style={{ borderRadius: 20 }} height={50} width={160} alt='Logo'></img>
            </Grid>
           </Grid>
           </Box>
    
          {/* Footer Text */}
          <Typography sx={styles.footerText} paddingTop={1}>
            © {new Date().getFullYear()} - Todos los derechos reservados.
          </Typography>

            </>
           )}
      </Box>
    </ThemeProvider>
  );
};

export default Footer;
